import {useState} from "react";

const forEachSeries = async (iterable, action) => {
  for (const x of iterable) {
    await action(x);
  }
};

const useTasker = (limit, action, onComplete) => {
  const [taskPercentage, setTaskPercentage] = useState(null);
  const [saving, setSaving] = useState(false);

  const resetTasker = () => {
    setSaving(false);
    setTaskPercentage(null);
  };

  const execute = async items => {
    const subLists = [];
    const nbSubLists = Math.ceil(items.length / limit);

    setSaving(true);

    for (let i = 0; i < nbSubLists; i++) {
      const slice = items.slice(i * limit, i * limit + limit);

      if (nbSubLists > 1) {
        setTaskPercentage(i / nbSubLists * 100);
      }

      await action(slice);
    }

    forEachSeries(subLists, action).then(() => {
      if (nbSubLists > 1) {
        setTaskPercentage(100);
      }

      setTimeout(() => onComplete(), 1000);
    });
  };

  return {execute, resetTasker, saving, taskPercentage};
};

export default useTasker;
